import React from 'react'
import ReactDOM from 'react-dom/client'
import { createTheme, ThemeProvider, CssBaseline } from '@mui/material'
import { Provider as JotaiProvider } from 'jotai'
import App from './App'

const theme = createTheme({
  palette: {
    mode: 'light',
    warning: {
      main: '#FFD700',
      contrastText: '#000',
    },
  },
  typography: {
    fontFamily: '"Noto Sans JP", "Helvetica Neue", "Arial", sans-serif',
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <JotaiProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </JotaiProvider>
  </React.StrictMode>
)
